import React from "react";
import { DownloadOutlined, FilePdfOutlined, LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { ReactComponent as IconMenu } from "../../../../assets/img/viewDoc.svg";

const Credentialing = ({
  items,
  filteredItems,
  selectedIds,
  searchValue,
  onSearchChange,
  onToggleSelected,
  onDownloadSelected,
  onView,
  downloadLoading,
}) => (
  <section className="new-3d-panel" id="new-3d-credentialing">
    <div className="new-3d-section-title">
      <div className="new-3d-section-heading">
        <span className="new-3d-section-icon"><FilePdfOutlined /></span>
        <h2>Credentialing</h2>
      </div>
    </div>

    {items.length ? (
      <>
        <div className="new-3d-credential-subtitle">
          Upload necessary credentials and documents that employers require
        </div>
        <div className="new-3d-credential-toolbar">
          <div className="new-3d-credential-search">
            <SearchOutlined />
            <input
              type="text"
              value={searchValue}
              onChange={(e) => onSearchChange?.(e.target.value)}
              placeholder="Search documents"
            />
          </div>
          <button
            type="button"
            className="new-3d-credential-download-selected"
            onClick={onDownloadSelected}
            disabled={selectedIds.length === 0 || downloadLoading}
          >
            {downloadLoading ? <Spin indicator={<LoadingOutlined />} /> : <DownloadOutlined />}
            <span>{downloadLoading ? "Downloading..." : "Download Selected"}</span>
          </button>
        </div>

        <div className="new-3d-credential-list">
          {filteredItems.map((item) => {
            const checked = selectedIds.includes(item.id);
            return (
              <article
                className={`new-3d-credential-row ${checked ? "new-3d-credential-row--selected" : ""}`}
                key={item.id}
              >
                <label className="new-3d-credential-check">
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => onToggleSelected(item.id)}
                  />
                </label>
                <button
                  type="button"
                  className="new-3d-credential-file-icon"
                  onClick={() => onView?.(item)}
                  aria-label={`View ${item.title || item.originalFileName || "credential"}`}
                >
                  <FilePdfOutlined />
                </button>
                <div className="new-3d-credential-copy">
                  <strong>{item.title || "Resume"}</strong>
                  <span>{item.originalFileName || "Document"}</span>
                  <span>{item.meta || "PDF"}</span>
                  <span>{item.dateLabel || "Uploaded document"}</span>
                </div>
                <button
                  type="button"
                  className="new-3d-credential-view-button"
                  onClick={() => onView?.(item)}
                  aria-label={`View ${item.title || item.originalFileName || "credential"}`}
                >
                  <IconMenu />
                </button>
              </article>
            );
          })}
        </div>
      </>
    ) : (
      <div className="new-3d-empty">No credentials added yet</div>
    )}
  </section>
);

export default Credentialing;
